import React from "react";

const TopNav = () => {
  let flag = 0;

  const openmenu = () => {
    let menubar = document.querySelector(".menu-bar");
    if (flag === 0) {
      menubar.style.display = "block";
      flag = 1;
    } else {
      menubar.style.display = "none";
      flag = 0;
    }
  };

  return (
    <>
      <div className="toptop">
        <div className="tonavbar1">
          <img src="/images/dedication_school_logo-removebg-preview.png" alt="" />
          <div className="imp">
            <h1 style={{ color: "#ffff" }}>
              <span id="firsth">D</span>EDICATION <span id="firsth">S</span>CHOOL{" "}
              <span id="firsth">O</span>F{" "}
              <span id="firsth">E</span>XCELLENCE
            </h1 >
            <p style={{ color: "#ffff" }}>The Sign Of Trust & Success.</p>
          </div>
        </div>
        <div className="menuimageicon">
          <i class="ri-menu-line" onClick={() => openmenu()}></i>
        </div>
      </div>
    </>
  );
};

export default TopNav;
